/* eslint-disable no-useless-escape */
<template>
  <div class="page-editor">
    <CRow>
      <CCol col="10" xl="10">
        <CCard class="pr-0">
          <CCardBody>
            <a-card class="edit-card" style="margin:0;">
              <span slot="title">
                <h6 class="w-100 mb-0 text-muted">Clearaudio – Mapovanie špecifikačných kľúčov</h6>
                <template>Spravujte párovanie scrapnutých kľúčov na interné termíny</template>
              </span>

              <div class="pt-4 pb-4">
                <div class="pl-4 pr-4">
                  <a-tabs default-active-key="mapper" class="w-100" tab-position="left">
                    <!-- === MAIN MAPPER === -->
                    <a-tab-pane tab="Mapovanie" key="mapper">
                      <div class="toolbar">
                        <a-input-search
                          v-model="filters.q"
                          placeholder="Hľadať kľúč / hodnotu…"
                          @search="noop"
                          class="mr-2 search"
                          allowClear
                        />
                        <a-select
                          v-model="filters.status"
                          placeholder="Stav"
                          class="mr-2 w-160"
                          allow-clear
                        >
                          <a-select-option value="unmapped">Nespárované</a-select-option>
                          <a-select-option value="mapped">Namapované</a-select-option>
                          <a-select-option value="ignored">Ignorované</a-select-option>
                        </a-select>

                        <a-select
                          v-model="filters.category"
                          placeholder="Kategória"
                          class="mr-2 w-220"
                          allow-clear
                          show-search
                          :filter-option="selectFilter"
                        >
                          <a-select-option
                            v-for="c in categories"
                            :key="c"
                            :value="c"
                          >{{ c }}</a-select-option>
                        </a-select>

                        <a-button class="mr-2" icon="thunderbolt" @click="autoMap" :loading="isAutomapping">
                          Auto-map
                        </a-button>
                        <a-button class="mr-2" icon="download" @click="exportCsv">
                          Export CSV (filter)
                        </a-button>
                      </div>

                      <a-table
                        :data-source="filteredRows"
                        :columns="columns"
                        :rowKey="row => row.id"
                        :pagination="pagination"
                        @change="onTableChange"
                        :rowClassName="rowClassName"
                        size="middle"
                        bordered
                      >
                        <!-- Source Key (EN + SK) -->
<template slot="source_key" slot-scope="text, record">
  <div class="key-cell">
    <a-tooltip :title="(record.sample_values && record.sample_values.join(', ')) || ''" >
      <span class="key">{{ record.source_key }}</span>
    </a-tooltip>

    <!-- SK translation shown under EN -->
    <div v-if="record.sk_label" class="key-sub text-muted">{{ record.sk_label }}</div>

    <a-tag v-if="record.source_category" class="ml-4" color="blue">
      {{ record.source_category }}
    </a-tag>
    <a v-if="record.sample_url" :href="record.sample_url" target="_blank" rel="noopener" class="ml-2">
      <a-icon type="link" />
    </a>
    <a-tag v-if="record.suggestion" color="green" class="ml-2">tip: {{ record.suggestion }}</a-tag>
  </div>
</template>


                        <!-- Map To (now using taxonomy/typeoptions: value = id, label = title) -->
                        <template slot="map_to" slot-scope="text, record">
                          <template v-if="termOptions.length">
                            <a-select
                              v-model="record.mapped_term"
                              show-search
                              class="w-100"
                              :filter-option="selectFilter"
                              @change="markDirty(record)"
                              allow-clear
                              placeholder="Vyber interný termín…"
                            >
                              <a-select-option
                                v-for="opt in termOptions"
                                :key="opt.value"
                                :value="opt.value"
                              >
                                <span class="opt-code">#{{ opt.value }}</span>
                                <span class="opt-label"> – {{ opt.label }}</span>
                              </a-select-option>
                            </a-select>
                          </template>
                          <template v-else>
                            <a-input
                              v-model="record.mapped_term"
                              placeholder="Zadaj ID položky zo slovníka (uloží sa do `code`)"
                              @change="markDirty(record)"
                            />
                          </template>
                        </template>

                        <!-- Status -->
                        <template slot="status" slot-scope="text, record">
                          <a-select v-model="record.status" class="w-140" @change="markDirty(record)">
                            <a-select-option value="unmapped">Nespárované</a-select-option>
                            <a-select-option value="mapped">Namapované</a-select-option>
                            <a-select-option value="ignored">Ignorované</a-select-option>
                          </a-select>
                        </template>

                        <!-- Notes -->
                        <template slot="notes" slot-scope="text, record">
                          <a-input
                            v-model="record.notes"
                            placeholder="Poznámka…"
                            @change="markDirty(record)"
                          />
                        </template>

                        <!-- Actions -->
                        <template slot="actions" slot-scope="text, record, index">
                          <a-button size="small" @click="copyDown(index)" :disabled="!record.mapped_term">Skopírovať ↓</a-button>
                          <a-popconfirm  title="Vrátiť úpravy tohto riadku?"    ok-text="Áno"
                            cancel-text="Nie"
                            @confirm="resetRow(record)"
                          >
                            <a-button size="small" class="ml-2">Reset</a-button>
                          </a-popconfirm>
                        </template>
                      </a-table>
                   </a-tab-pane>

                    <a-tab-pane tab="Nespárované" key="unmapped">
                      <a-alert type="info" show-icon class="mb-3"
                        message="Zobrazené sú iba kľúče bez mapovania (status: Nespárované)." />
                      <a-table
                        :data-source="onlyUnmapped"
                        :columns="unmappedCols"
                        :rowKey="row => row.id"
                        size="small"
                        bordered
                        :pagination="false"
                      />
                    </a-tab-pane>

                    <!-- === SETTINGS (read-only for now) === -->
                    <a-tab-pane tab="Nastavenia" key="settings">
                      <a-descriptions bordered :column="1" size="small">
                        <a-descriptions-item label="Počet načítaných kľúčov">{{ rows.length }}</a-descriptions-item>
                        <a-descriptions-item label="Počet termínov v slovníku">{{ termOptions.length }}</a-descriptions-item>
                        <a-descriptions-item label="Auto-map heuristika">
                          Porovnanie normalizovaného kľúča so <i>slovníkovým labelom</i> (title). Pri zhode nastavíme ID položky.
                        </a-descriptions-item>
                      </a-descriptions>
                    </a-tab-pane>
                  </a-tabs>
                </div>
              </div>
            </a-card>
          </CCardBody>
        </CCard>
      </CCol>

      <!-- SIDE ACTIONS -->
      <CCol col="2" xl="2" class="option-card">
        <CCard class="pl-0">
          <CCardBody>
            <a-card class="edit-card" style="margin:0; padding:15px;">
              <div class="option-buttons">
                <router-link to="/importers"><a-button>Späť</a-button></router-link>
                <a-button type="primary" class="fs-12 mt-2" @click="handleSave" :loading="isSaving" :disabled="dirtyCount===0">
                  Uložiť zmeny ({{ dirtyCount }})
                </a-button>
                <a-button class="fs-12 mt-2" @click="refreshAll" :loading="isLoading">Znovu načítať</a-button>
              </div>
            </a-card>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
  </div>
</template>

<script>
import { API_URL } from "../api";
import { authHeader } from "../_helpers";
import { dataService } from "../_services";
import Vue from "vue";
import FormItem from "ant-design-vue";

Vue.use(FormItem);

/**
 * Endpoints:
 *  GET  ca_spec_keys_all       -> rows from ca_spec_keys (code now holds taxonomy item ID as string)
 *  GET  taxonomy/typeoptions   -> dictionary items [{ id, title, ... }]
 *  POST ca_save_mappings       -> { items: [{ id, mapped_term, status, notes }] }
 */
const EP = {
  ALL: "ca_spec_keys_all",
  TERMS: "taxonomyitems/typeoptions",
  SAVE: "ca_save_mappings",
};

export default {
  name: "clearaudio-mapper",
  data() {
    return {
      head: authHeader(),
      send: API_URL,

      colorsto: localStorage.colors ? JSON.parse(localStorage.colors) : {},
      isLoading: false,
      isSaving: false,
      isAutomapping: false,

      rows: [],
      original: new Map(), // id -> shallow copy for reset
      termOptions: [],     // [{value: id (string), label: title}]
      termIndex: new Map(),// id(string) -> label
      categories: [],

      filters: {
        q: "",
        status: undefined,
        category: undefined,
      },

      pagination: { pageSize: 20, current: 1 },

      columns: [
        { title: "Kľúč (zdroj)", dataIndex: "source_key", key: "source_key", scopedSlots: { customRender: "source_key" }, width: 360 },
        { title: "Namapovať na (interný termín)", dataIndex: "mapped_term", key: "mapped_term", scopedSlots: { customRender: "map_to" } },
        { title: "Stav", dataIndex: "status", key: "status", width: 180, scopedSlots: { customRender: "status" } },
        { title: "Poznámka", dataIndex: "notes", key: "notes", width: 260, scopedSlots: { customRender: "notes" } },
        { title: "", key: "actions", width: 160, align: "right", scopedSlots: { customRender: "actions" } },
      ],

      unmappedCols: [
        { title: "Kľúč", dataIndex: "source_key", key: "source_key" },
        { title: "Kategória", dataIndex: "source_category", key: "source_category", width: 180 },
        { title: "Návrh", dataIndex: "suggestion", key: "suggestion", width: 220 },
      ],
    };
  },
  computed: {
    filteredRows() {
      const q = (this.filters.q || "").toLowerCase().trim();
      return this.rows.filter(r => {
        if (this.filters.status && r.status !== this.filters.status) return false;
        if (this.filters.category && r.source_category !== this.filters.category) return false;

        if (!q) return true;
        const mappedLabel = this.termIndex.get(String(r.mapped_term)) || "";
        const hay = [
  r.source_key || "",
  r.sk_label || "",
  (r.mapped_term || ""),
  mappedLabel || "",
  (r.suggestion || ""),
  (r.sample_url || ""),
  ...(r.sample_values || []),
].join(" ").toLowerCase();
        return hay.includes(q);
      });
    },
    onlyUnmapped() {
      return this.rows.filter(r => r.status === "unmapped");
    },
    dirtyCount() {
      return this.rows.reduce((acc, r) => acc + (r._dirty ? 1 : 0), 0);
    },
  },
  methods: {
    noop() {},

    selectFilter(input, option) {
      const children = (option && option.componentOptions && option.componentOptions.children) || [];
      const txt = children.map(v => (v.text || "").toString().toLowerCase()).join(" ");
      return txt.includes((input || "").toLowerCase());
    },

    rowClassName(record) {
      if (record._dirty) return "row-dirty";
      if (record.status === "unmapped") return "row-unmapped";
      if (record.status === "ignored") return "row-ignored";
      return "";
    },

    onTableChange(pager) {
      this.pagination = pager;
    },

    async refreshAll() {
      this.isLoading = true;
      try {
        const [payload, dict] = await Promise.all([
          dataService.axiosFetch(EP.ALL),
          dataService.axiosFetch(EP.TERMS),
        ]);

        // keys
        const keys = Array.isArray(payload) ? payload : (payload.keys || []);
        this.rows = (keys || []).map(k => {
          const mapped = (k.mapped_term != null && k.mapped_term !== "")
            ? String(k.mapped_term)
            : (k.code != null && k.code !== "" ? String(k.code) : null);

          const normalized = {
  id: k.id,
  source_key: k.source_key || k.key_raw,
  source_category: k.source_category || k.category || null,
  sample_values: k.sample_values || (k.sample_value ? [k.sample_value] : []),
  sample_url: k.sample_url || null,
  suggestion: k.suggestion || null,

  sk_label: k.sk_label || k.key_sk || null,

  mapped_term: mapped,
  status: k.status || (mapped ? "mapped" : "unmapped"),
  notes: k.notes || "",
  _dirty: false,
};
  this.original.set(normalized.id, { ...normalized });
          return normalized;
        });
        // terms (dictionary)
          const items = Array.isArray(dict) ? dict : (dict.items || dict.data || []);
    this.termOptions = (items || []).map(t => ({
      value: String(t.id),
      label: t.title || t.name || String(t.id),
    }));
         // sort by label with Slovak collator, fallback to case-insensitive
    const collator = new Intl.Collator("sk", { sensitivity: "base" });
    this.termOptions.sort((a, b) => collator.compare(a.label, b.label));

    // map id -> label (na zobrazovanie labelu v tabuľke/CSV)
    this.termIndex = new Map(this.termOptions.map(o => [o.value, o.label]));


      } finally {
        this.isLoading = false;
      }
    },

    markDirty(row) {
      const orig = this.original.get(row.id);
      row._dirty = !orig || (
        String(row.mapped_term || "") !== String(orig.mapped_term || "") ||
        (row.status || "") !== (orig.status || "") ||
        (row.notes || "") !== (orig.notes || "")
      );
    },

    resetRow(row) {
      const orig = this.original.get(row.id);
      if (!orig) return;
      row.mapped_term = orig.mapped_term;
      row.status = orig.status;
      row.notes = orig.notes;
      row._dirty = false;
    },

    copyDown(index) {
      const src = this.filteredRows[index];
      if (!src || !src.mapped_term) return;
      for (let i = index + 1; i < this.filteredRows.length; i++) {
        const r = this.filteredRows[i];
        if (r.status === "ignored") continue;
        r.mapped_term = src.mapped_term; // copy ID
        if (!r.status || r.status === "unmapped") r.status = "mapped";
        this.markDirty(r);
      }
    },

    norm(s) {
      return (s || "")
        .toString()
        .trim()
        .toLowerCase()
        .replace(/[_\-:]+/g, " ")
        .replace(/\s+/g, " ");
    },

    autoMap() {
      if (!this.termOptions.length) {
        this.$message.info("Auto-map potrebuje načítaný slovník (taxonomy/typeoptions).");
        return;
      }
      this.isAutomapping = true;
      try {
        // Build label index: normalized label -> ID
        const byLabel = new Map(this.termOptions.map(t => [this.norm(t.label), t.value]));

        let hits = 0;
        this.rows.forEach(r => {
          if (r.status === "mapped" && r.mapped_term) return;
          const k = this.norm(r.source_key);
          const found = byLabel.get(k);
          if (found) {
            r.mapped_term = found;   // ID
            r.status = "mapped";
            this.markDirty(r);
            hits++;
          }
        });

        this.$message.success(`Auto-map: spárované ${hits} kľúčov.`);
      } finally {
        this.isAutomapping = false;
      }
    },

    async handleSave() {
      const items = this.rows
        .filter(r => r._dirty)
        .map(r => ({
          id: r.id,
          // backend will store this into ca_spec_keys.code (string) – it now contains taxonomy item ID
          mapped_term: r.mapped_term ? String(r.mapped_term) : null,
          status: r.status,
          notes: r.notes || "",
        }));

      if (items.length === 0) {
        this.$message.info("Nie je čo uložiť.");
        return;
      }

      this.isSaving = true;
      try {
        const res = await dataService.axiosPost(EP.SAVE, { items });
        if (res && res.data && res.data.success === false) {
          this.$message.error(res.data.message || "Ukladanie zlyhalo.");
          return;
        }
        // Update originals on success
        items.forEach(it => {
          const row = this.rows.find(r => r.id === it.id);
          if (!row) return;
          row._dirty = false;
          this.original.set(row.id, { ...row });
        });
        this.$message.success("Zmeny uložené.");
      } catch (e) {
        this.$message.error("Ukladanie zlyhalo.");
      } finally {
        this.isSaving = false;
      }
    },

    exportCsv() {
      const headers = [
        "id",
        "source_key",
        "source_category",
        "mapped_term_id",
        "mapped_label",
        "status",
        "suggestion",
        "sample_values",
        "sample_url",
        "notes",
      ];
      const lines = [headers.join(";")];
      this.filteredRows.forEach(r => {
        const row = [
          r.id,
          this.csvSafe(r.source_key),
          this.csvSafe(r.source_category),
          this.csvSafe(r.mapped_term || ""),
          this.csvSafe(this.termIndex.get(String(r.mapped_term || "")) || ""),
          r.status,
          this.csvSafe(r.suggestion),
          this.csvSafe((r.sample_values || []).join(", ")),
          this.csvSafe(r.sample_url || ""),
          this.csvSafe(r.notes),
        ];
        lines.push(row.join(";"));
      });
      const blob = new Blob([lines.join("\n")], { type: "text/csv;charset=utf-8" });
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = "clearaudio-mapping.csv";
      a.click();
      URL.revokeObjectURL(url);
    },

    csvSafe(v) {
      if (v == null) return "";
      const s = v.toString().replace(/"/g, '""');
      if (/[;,"\n]/.test(s)) return `"${s}"`;
      return s;
    },
  },

  async mounted() {
    await this.refreshAll();
  },
};
</script>

<style>
.toolbar { display:flex; align-items:center; margin-bottom: 16px; flex-wrap: wrap; }
.toolbar .search { width: 320px; }
.w-100 { width:100%; }
.w-140 { width:140px; }
.w-160 { width:160px; }
.w-220 { width:220px; }
.ml-2 { margin-left:8px; }
.ml-4 { margin-left:16px; }
.mr-2 { margin-right:8px; }
.mt-2 { margin-top:8px; }
.mb-3 { margin-bottom:12px; }

.key-cell .key { font-weight: 600; }
.opt-code { font-family: ui-monospace, SFMono-Regular, Menlo, monospace; }
.opt-label { opacity: .85; }
.key-sub { font-size: 12px; margin-top: 2px; }
.text-muted { opacity: .65; }
.row-dirty { background: #fff8f0 !important; }
.row-unmapped { background: #fffef2 !important; }
.row-ignored { background: #f7f8fa !important; }
</style>
